import React from 'react';

const Icon = ({ size = '35', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 35 35" fill="none" {...other}>
            <path
                d="M8.116 26.676a13.086 13.086 0 0 0 9.384 3.949c7.248 0 13.125-5.877 13.125-13.125S24.748 4.375 17.5 4.375a13.081 13.081 0 0 0-9.106 3.673"
                stroke="white"
                strokeWidth="2.188"
                strokeLinecap="round"
            />

            <path
                d="M17.5 10.208v8.75l5.833-2.916M7.292 11.667 3.646 17.5H8.75l-3.646 5.833"
                stroke="white"
                strokeWidth="2.188"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export default React.memo(Icon);
